import React from 'react'
import View from './view'

const EventTicket = ({ ...props }) => {
    return <View {...props} />
}

export default EventTicket
